import moment from 'moment';

const getTime = (scheduledTime, duration) => {
  if (scheduledTime) {
    return {
      hourStart: moment(scheduledTime).format('H'),
      minutesStart: moment(scheduledTime).format('m'),
      hourEnd: moment(scheduledTime + 1000 * 60 * duration).format('H'),
      minutesEnd: moment(scheduledTime + 1000 * 60 * duration).format('m')
    };
  } // This gets the time string displayed in the middle of the calendar
  // Maybe there's a better way to get this value from the Calendar component

  /**
   * @type {HTMLElement}
   */


  const target = document.querySelector('#opsTime');
  const timeStr = target.innerText.split(' ');
  const hourStart = timeStr[0].split(':').map(x => parseInt(x))[0];
  const minutesStart = timeStr[0].split(':').map(x => parseInt(x))[1];
  const hourEnd = timeStr[2].split(':').map(x => parseInt(x))[0];
  const minutesEnd = timeStr[2].split(':').map(x => parseInt(x))[1];
  return {
    hourStart,
    minutesStart,
    hourEnd,
    minutesEnd
  };
};

export default getTime;